// extracted by mini-css-extract-plugin
module.exports = {"inline":"inline--1-Hk_"};